import type { Timestamp } from 'firebase/firestore';
import { Link } from 'react-router-dom';

/**
 * Padrão 5: toda ficha diz de onde veio.
 *
 * Rodapé fixo em produto, fornecedor, cotação, análise e oportunidade. Num
 * sistema compartilhado entre amigos, saber quem mexeu evita metade das
 * discussões (RN-008).
 */
function dataHora(ts: Timestamp | null | undefined): string | null {
  if (!ts) return null;
  return ts.toDate().toLocaleDateString('pt-BR');
}

export function Procedencia({
  criadoPor,
  criadoEm,
  atualizadoPor,
  atualizadoEm,
  entidade,
  entidadeId,
  nomes,
}: {
  criadoPor: string;
  criadoEm: Timestamp | null;
  atualizadoPor?: string | null;
  atualizadoEm?: Timestamp | null;
  entidade: string;
  entidadeId: string;
  nomes: Record<string, string>;
}) {
  const nome = (uid: string) => nomes[uid] ?? 'usuário removido';
  const criado = dataHora(criadoEm);
  const alterado = dataHora(atualizadoEm);

  return (
    <footer className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 border-t border-regua pt-3 font-mono text-[0.72rem] text-tinta-3">
      {criado && (
        <span>
          criado por {nome(criadoPor)} em {criado}
        </span>
      )}
      {alterado && atualizadoPor && (
        <>
          <span aria-hidden>·</span>
          <span>
            alterado por {nome(atualizadoPor)} em {alterado}
          </span>
        </>
      )}
      <span aria-hidden>·</span>
      <Link
        to={`/historico?entidade=${entidade}&id=${entidadeId}`}
        className="text-marca underline-offset-2 hover:underline"
      >
        ver histórico
      </Link>
    </footer>
  );
}
